import React, { FC } from 'react'
import lockIcon from '../assets/lock-icon.png'
import { Button, EmptyPage } from '@sistemiv/s-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const NotAuthorized: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { logoutUrl } = useAuth()

  const handleLogout = async () => {
    logoutUrl && window.location.replace(logoutUrl)
  }

  return (
    <EmptyPage imageUrl={lockIcon} imageAlt={'Not authorized'} message={t('NotAuth.notAuthMsg')}>
      <Button className='text-sky-500 text-lg hover:bg-gray-100 transition-all' onClick={() => navigate(-1)}>
        {t('NotAuth.goBack')}
      </Button>
      <Button className='text-sky-500 text-lg hover:bg-gray-100 transition-all' onClick={handleLogout}>
        {t('NotAuth.logInFromOther')}
      </Button>
    </EmptyPage>
  )
}

export default NotAuthorized
